import { createSlice } from '@reduxjs/toolkit'

export const caseSlice = createSlice({
  name: 'case',
  initialState: {
    optional_cases_details: [],
    optional_cases_list: [],
    cases_list: [],
    shipment_list: [],
    last_case_date: null
  },
  reducers: {
    setOptionalCasesDetails: (state, action) => {
      state.optional_cases_details = action.payload;
    },
    setOptionalCasesList: (state, action) => {
      state.optional_cases_list = action.payload;
    },
    setCases: (state, action) => {
      state.cases_list = action.payload;
    },
    setShipmentCases: (state, action) => {
      state.shipment_list = action.payload;
    },
    setLastCaseDate: (state, action) => {
      state.last_case_date = action.payload;
    },
    setShipmentdocuments: (state, action) => {
      state.shipment_list[action.payload['index']]['documents'] = action.payload['documents'];
    }
  },
})
export const { setOptionalCasesDetails, setOptionalCasesList, setCases,setShipmentCases,setShipmentdocuments, setLastCaseDate } = caseSlice.actions
export default caseSlice.reducer